import { IHouseOfferHistoryV4Schema } from 'shared/repositories/valuation-offer-history/entities/offer_history/HouseOfferHistoryV4Schema';
import { IOffersHistoryListingData } from 'shared/types/offersHistory';
import { getOfferDeactivatedLabel, getOfferDateEnd } from 'shared/utils/offerHistory';

export const prepareOffers = (offers: IHouseOfferHistoryV4Schema[]): IOffersHistoryListingData['offers'] => {
  return offers.map(offer => ({
    ...offer,
    deactivatedTitle: getOfferDeactivatedLabel(offer),
    dateEnd: getOfferDateEnd(offer),
    expositionFull: `${offer.exposition} на Циан`,
  }));
};
